import { toast } from "sonner";
import api, { apiErr } from "@/lib/api";

// WhatsApp pela Twilio (teste, só na agência de demonstração): o processo aberto diz se está ligado.
export const twilio = { pid: null, on: false };
export const twilioFor = (pid) => twilio.on && twilio.pid === pid;

const waMe = (phone, text) => {
  const d = String(phone || "").replace(/\D/g, "").replace(/^(9\d{8})$/, "351$1");
  return `https://wa.me/${d}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
};

// Envia pela Twilio; se falhar, mostra o erro e oferece «Abrir no WhatsApp».
export async function sendWa(pid, phone, text) {
  try {
    await api.post(`/processes/${pid}/whatsapp`, { phone, text });
    toast.success("Mensagem enviada por WhatsApp (Twilio)");
    return true;
  } catch (e) {
    const msg = apiErr(e.response?.data?.detail);
    if (e.response?.status === 403) toast.error(msg);
    else toast.error(msg, { duration: 15000, action: { label: "Abrir no WhatsApp", onClick: () => window.open(waMe(phone, text), "_blank") } });
    return false;
  } finally {
    window.dispatchEvent(new Event("imodesk:wa-sent"));
  }
}

// Botões de WhatsApp do processo: Twilio se ligado, senão wa.me como hoje.
export function openWa(pid, phone, text) {
  if (twilioFor(pid)) { sendWa(pid, phone, text); return; }
  window.open(waMe(phone, text), "_blank");
}

// Com a Twilio ligada, o WhatsApp dos Contactos abre a secção «Mensagens» do processo.
export const openMsgs = (detail = {}) => window.dispatchEvent(new CustomEvent("imodesk:msgs-open", { detail }));
